import "../assets/css/vendor-product-forms.css";
import React, { useCallback, useEffect, useState, useRef } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import {
  Alert,
  Card,
  Form,
  Button,
  Container,
  Row,
  Col,
  Modal,
  Spinner,
} from "react-bootstrap";
import DiscountFields, { discountPayloadOf } from "../components/DiscountFields";
import { useProductFormGate } from "../components/team/Gated";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Switch, FormControlLabel } from "@material-ui/core";
import { AppAsyncSelect as AsyncSelect } from "../components/ui/AppReactSelect";
import CategorySuggestions from "../components/catalog/CategorySuggestions";
import { categoryPickerOptions, unitSelectOptions } from "../utilities/catalogTaxonomy";
import ReactCrop from "react-image-crop";
import { centerCrop, makeAspectCrop } from "react-image-crop";
import { IconButton, Tooltip } from "@material-ui/core";
import { MdCrop, MdCropSquare, MdCropLandscape } from "react-icons/md";

import {
  fetchRetailerWholesalerProductDetails,
  updateRetailerWholesalerProduct,
  deleteRetailerWholesalerProduct,
} from "../actions/retailerWholesalerProductActions";
import {
  fetchRetailerWholesalerSections,
  fetchRetailerWholesalers,
} from "../actions/retailerWholesalerSectionActions";
import {
  fetchRetailerWholesalerOptionGroups,
  createRetailerWholesalerOptionGroup,
} from "../actions/retailerWholesalerOptionActions";
import { apiGetCodPolicy } from "../api";
import { format } from "date-fns";
import { FaTrash } from "react-icons/fa";
import { uploadImageToCloudinary as sharedUpload } from "../utilities/imageUpload";
import { toast } from "react-toastify";
import Select from "../components/ui/AppReactSelect";
import { getUserFromLocalStorage } from "../utilities/user";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  DESCRIPTION_QUILL_MODULES,
  DESCRIPTION_QUILL_FORMATS,
  DESCRIPTION_EDITOR_CLASS,
  DESCRIPTION_TYPOGRAPHY_CSS,
  liftPlainTextToHtml,
  normalizeStoredDescriptionHtml,
  quillHtmlToPlainText,
} from "../utilities/richText";
import ProductImageSection from "../components/ProductImageSection";
import ProductFreightFields, {
  serialiseProductFulfillment,
} from "../components/ProductFreightFields";
import ProductMediaDeleteDialog from "../components/ProductMediaDeleteDialog";
import ProductVideoSection from "../components/ProductVideoSection";
import AppSelect from "../components/ui/AppSelect";
import { vendorOwnerIdOf } from "../utilities/vendorScope";

const useStyles = makeStyles((theme) => ({
  label: {
    fontWeight: "normal",
    fontSize: "12px",
    textTransform: "capitalize",
  },
}));

const ASPECT_RATIO = 1;
const MIN_DIMENSION = 1000;
const PREVIEW_CONTAINER_SIZE = 300;

const EditCatalogProductForm = () => {
  const classes = useStyles();
  const { productId } = useParams();
  const user = getUserFromLocalStorage();
  const vendorId = vendorOwnerIdOf(user);

  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();

  const [productDetails, setProductDetails] = useState(
    location.state?.productDetails || { optionGroups: [] }
  );

  /* Catalog quality-control mode: staff admins arriving from the
     /admin/rw-vendors QC flow edit through the admin-authorized endpoint
     and return to the vendors table when done. */
  const qcAdmin = Boolean(location.state?.qcAdmin);
  const isStaffAdmin =
    user?.result?.userType === "LUSUKU STAFF" &&
    (["SUPERUSER", "SUPERADMIN", "ADMIN"].includes(user?.result?.user_role) ||
      user?.result?.isSuperAdmin);
  const asAdmin = qcAdmin && isStaffAdmin;
  /* The Quill editor edits the rich HTML. Stored HTML is normalized on load
     (heals legacy entity double-encoding, upgrades "<p>• …</p>" to real
     lists); legacy plain-only products are lifted into semantic HTML the
     same way (bullet lines → <ul><li>). Either way the editor shows true
     bullets and the next save persists the upgraded data. */
  const initialDescriptionHtml =
    normalizeStoredDescriptionHtml(
      location.state?.productDetails?.descriptionHtml
    ) || liftPlainTextToHtml(location.state?.productDetails?.description);
  const [descriptionHtml, setDescriptionHtml] = useState(initialDescriptionHtml);

  const sections = useSelector(
    (state) => state.retailerWholesalerSections.sectionsRW
  );
  const retailersWholesalers = useSelector(
    (state) => state.retailerWholesalerSections.retailersWholesalers
  );
  const optionGroups = useSelector(
    (state) => state.retailerWholesalerOptions.optionGroups
  );
  const options = useSelector(
    (state) => state.retailerWholesalerOptions.options
  );

  const [imagePreview, setImagePreview] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isFormatCorrect, setIsFormatCorrect] = useState(true);
  const [isSizeCorrect, setIsSizeCorrect] = useState(true);
  const [isResolutionCorrect, setIsResolutionCorrect] = useState(true);
  const [formErrors, setFormErrors] = useState({
    section: "",
    retailerWholesaler: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const gate = useProductFormGate(submitting || uploading);
  // Saved photo (https URL) whose X was clicked; opens ProductMediaDeleteDialog.
  const [photoDeleteTarget, setPhotoDeleteTarget] = useState(null);

  const [selectedOptionGroups, setSelectedOptionGroups] = useState([]);
  const [optionGroupName, setOptionGroupName] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [showOptionGroupModal, setShowOptionGroupModal] = useState(false);
  const [minOptions, setMinOptions] = useState(0);
  const [maxOptions, setMaxOptions] = useState(0);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [operationMode, setOperationMode] = useState("");
  const [selectedUnit, setSelectedUnit] = useState([]);
  const [inputValue, setValue] = useState("");
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isLoadingUnits, setIsLoadingUnits] = useState(false);
  // Live COD max product amount (UGX). Products priced above it can't be COD.
  const [codMaxAmount, setCodMaxAmount] = useState(null);

  const [aspect, setAspect] = useState(undefined);
  const [crop, setCrop] = useState({
    unit: "%",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
  });
  const [completedCrop, setCompletedCrop] = useState(null);
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);

  const [uploadError, setUploadError] = useState(null);

  /* In QC mode a staff admin opens this form, so the OWNING vendor's data
     (sections, option groups…) must be fetched with the product owner's id
     (product.retailerWholesalerId refs the owner user) — not the admin's. */
  const ownerVendorId = asAdmin
    ? String(
        location.state?.productDetails?.retailerWholesalerId?._id ||
          location.state?.productDetails?.retailerWholesalerId ||
          vendorId
      )
    : vendorId;

  useEffect(() => {
    dispatch(fetchRetailerWholesalerProductDetails(productId));
    dispatch(fetchRetailerWholesalerSections(ownerVendorId));
    // Staff editing another store's product (QC mode) can't use the
    // vendor-scoped list route — pass asAdmin so it hits /rw/admin-directory.
    dispatch(fetchRetailerWholesalers(ownerVendorId, asAdmin));
    dispatch(fetchRetailerWholesalerOptionGroups(ownerVendorId));
    fetchCategories();
  }, [dispatch, productId, ownerVendorId, asAdmin]);

  // Load the live COD max product amount so the toggle can lock itself for
  // high-value products. Falls back silently to the shipped default on error.
  useEffect(() => {
    let active = true;
    apiGetCodPolicy()
      .then(({ data }) => {
        if (active && Number(data?.maxProductAmount) > 0) {
          setCodMaxAmount(Number(data.maxProductAmount));
        }
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    if (retailersWholesalers?.length > 0) {
      // In admin-directory mode the list holds ALL vendors, so pick the one
      // owning this product (match on owner, stable across both list modes)
      // rather than blindly [0]. Fall back to [0] for the single-vendor case.
      const ownerStore =
        retailersWholesalers.find(
          (rw) =>
            String(rw.owner) === String(ownerVendorId) ||
            String(rw._id) === String(ownerVendorId)
        ) || retailersWholesalers[0];
      setOperationMode(ownerStore.operationMode);
    }
    // Fetch unit details if unit_id exists
    if (productDetails?.unit_id) {
      setIsLoadingUnits(true);
      fetch(`/unit/${productDetails.unit_id}`)
        .then((res) => res.json())
        .then((unitData) => {
          if (unitData) {
            setSelectedUnit({
              value: unitData._id,
              label: unitData.unit,
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching unit details:", error);
        })
        .finally(() => {
          setIsLoadingUnits(false);
        });
    }
  }, [productDetails.unit_id]);

  const fetchCategories = async () => {
    try {
      const res = await fetch("/category/get-all");
      const allCategories = await res.json();
      setCategories(allCategories);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    if (Array.isArray(productDetails.category) && categories.length > 0) {
      const initialSelectedCategories = productDetails.category
        .map((categoryId) => {
          const category = categories.find((c) => c._id === categoryId);
          return category
            ? { value: category._id, label: category.category }
            : null;
        })
        .filter(Boolean);
      setSelectedCategory(initialSelectedCategories);
    }
  }, [productDetails.category, categories]);

  useEffect(() => {
    if (
      Array.isArray(productDetails?.optionGroups) &&
      optionGroups?.length > 0
    ) {
      const initialSelectedOptionGroups = productDetails.optionGroups.map(
        (optionGroupId) => {
          const matchedGroup = optionGroups.find(
            (group) => group._id === optionGroupId
          );
          return matchedGroup
            ? {
              value: matchedGroup._id,
              label: `${matchedGroup.name} (Min: ${matchedGroup.minOptions}, Max: ${matchedGroup.maxOptions})`,
              minOptions: matchedGroup.minOptions,
              maxOptions: matchedGroup.maxOptions,
            }
            : {
              value: optionGroupId,
              label: "Unknown Group",
              minOptions: 0,
              maxOptions: 0,
            };
        }
      );
      setSelectedOptionGroups(initialSelectedOptionGroups);
    }
  }, [productDetails.optionGroups, optionGroups]);

  // Function to load categories for AsyncSelect
  // Grouped, "All"/"Random"/inactive left out (unless already chosen),
  // aliases and keywords searchable. This picker uses {value, label} options.
  const loadCategory = useCallback(async (inputValue) => {
    try {
      const res = await fetch("/category/get-all");
      const allCategories = await res.json();
      return categoryPickerOptions(Array.isArray(allCategories) ? allCategories : [], {
        input: inputValue,
        selected: selectedCategory,
      }).map((group) => ({
        label: group.label,
        options: group.options.map((category) => ({
          value: category._id,
          label: category.category,
        })),
      }));
    } catch (error) {
      console.error("Error loading categories:", error);
      return [];
    }
  }, [selectedCategory]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "countInStock" && value < 1) {
      toast.error("Count in Stock cannot be less than 1");
      return;
    }

    setProductDetails({ ...productDetails, [name]: value });
    if (formErrors[name]) {
      setFormErrors({ ...formErrors, [name]: "" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = { section: "", retailerWholesaler: "" };

    if (!productDetails.sectionId) {
      errors.section = "Section is required";
    }
    if (!productDetails.retailerWholesalerId) {
      errors.retailerWholesaler = "Retailer/Wholesaler is required";
    }

    if (errors.section || errors.retailerWholesaler) {
      setFormErrors(errors);
      return;
    }

    setSubmitting(true);
    setUploading(true);
    let uploadedImageUrl = productDetails.image;

    if (
      uploadedImageUrl &&
      typeof uploadedImageUrl === "string" &&
      uploadedImageUrl.startsWith("data:")
    ) {
      uploadedImageUrl = await uploadImageToCloudinary(uploadedImageUrl);
      if (!uploadedImageUrl) {
        toast.error("Image upload failed, please try again.");
        setUploading(false);
        setSubmitting(false);
        return;
      }
    } else if (!uploadedImageUrl) {
      toast.error("Please add an image to the product.");
      setUploading(false);
      setSubmitting(false);
      return;
    }

    /* Resolve newly-picked extra angles. The strip stores either
       https URLs (already saved) or dataURLs (just picked). Backend
       diffs against stored array and reclaims orphans. */
    let resolvedAdditional = [];
    const picked = Array.isArray(productDetails?.additionalImages)
      ? productDetails.additionalImages
      : [];
    for (const entry of picked) {
      if (typeof entry !== "string" || !entry) continue;
      if (entry.startsWith("data:")) {
        // eslint-disable-next-line no-await-in-loop
        const url = await uploadImageToCloudinary(entry, "product_angle");
        if (!url) {
          toast.error("One of the extra angles failed to upload.");
          setUploading(false);
          setSubmitting(false);
          return;
        }
        resolvedAdditional.push(url);
      } else {
        resolvedAdditional.push(entry);
      }
    }

    const selectedPaymentRequirement =
      productDetails.requiredPaymentMethod ||
      (productDetails.codDisabled ? "ANY_ONLINE" : "NONE");
    const effectivePaymentRequirement =
      codMaxAmount != null &&
      Number(productDetails.price) > codMaxAmount &&
      selectedPaymentRequirement === "NONE"
        ? "ANY_ONLINE"
        : selectedPaymentRequirement;

    const updatedProductDetails = {
      ...productDetails,
      /* WYSIWYG pipeline: send the Quill HTML; the server sanitizes it and
         derives the authoritative plain-text `description` from it. The
         client-derived copy keeps older backends degrading gracefully. */
      description: quillHtmlToPlainText(descriptionHtml),
      descriptionHtml,
      image: uploadedImageUrl,
      additionalImages: resolvedAdditional,
      /* `videos` rides in via the ...productDetails spread ONLY when the key
         exists in state — its absence must stay absence, so the server's
         "no videos key = leave stored videos alone" rule keeps working for
         stale navigations that predate the video feature. */
      optionGroups: selectedOptionGroups.map((group) => ({
        _id: group.value,
      })),
      unit_id: selectedUnit.value,
      category: selectedCategory.map((cat) => cat.value),
      requiredPaymentMethod: effectivePaymentRequirement,
      discount: discountPayloadOf(productDetails.discount),
      // Backward-compatible mirror for older installed clients.
      codDisabled: effectivePaymentRequirement !== "NONE",
      fulfillment: serialiseProductFulfillment(productDetails.fulfillment),
    };

    try {
      await dispatch(
        updateRetailerWholesalerProduct(productId, updatedProductDetails, {
          asAdmin,
        })
      );
      // toast.success('Product updated successfully');
    } catch (error) {
      toast.error("Failed to update product");
    } finally {
      setSubmitting(false);
      // QC edits return to the vendors table; vendor edits to their catalog.
      history.push(location.state?.returnTo || "/admin/catalog");
    }
  };

  // Takes a File rather than a change event: the image section now accepts
  // drag-and-drop, and a drop has no <input> to read `target.files` from.
  const handleImageFile = (file) => {
    if (!file) {
      setUploadError("No file was selected.");
      toast.error("No file was selected.");
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        setImagePreview(reader.result);
        setProductDetails((prev) => ({ ...prev, image: reader.result }));
        setShowPreviewModal(true);

        const validFormats = ["image/jpeg", "image/png"];
        const isCurrentFormatCorrect = validFormats.includes(file.type);
        const isCurrentSizeCorrect = file.size <= 10 * 1024 * 1024;
        const isCurrentResolutionCorrect =
          img.width >= 1000 && img.height >= 1000;

        setIsFormatCorrect(isCurrentFormatCorrect);
        setIsSizeCorrect(isCurrentSizeCorrect);
        setIsResolutionCorrect(isCurrentResolutionCorrect);

        if (
          !isCurrentFormatCorrect ||
          !isCurrentSizeCorrect ||
          !isCurrentResolutionCorrect
        ) {
          let errorMessage =
            "Please ensure the image meets all the requirements:";
          if (!isCurrentFormatCorrect)
            errorMessage += " Must be JPG or PNG format.";
          if (!isCurrentSizeCorrect)
            errorMessage += " Must be less than or equal to 10MB.";
          if (!isCurrentResolutionCorrect)
            errorMessage += " Must be at least 1000x1000 pixels.";
          setUploadError(errorMessage);
        } else {
          setUploadError(null);
        }
      };
      img.onerror = () => {
        setUploadError("There was an error processing your image.");
        setImagePreview(null);
        setShowPreviewModal(false);
        toast.error("There was an error processing your image.");
      };
      img.src = reader.result;
    };
    reader.onerror = () => {
      setUploadError("Failed to read the image file.");
      setImagePreview(null);
      setProductDetails((prev) => ({ ...prev, image: null }));
      setShowPreviewModal(false);
    };
    reader.readAsDataURL(file);
  };

  const uploadImageToCloudinary = async (file, assetPurpose = "product_cover") => {
    if (!file) {
      toast.error("No image file selected!");
      return null;
    }

    setUploading(true);
    try {
      const result = await sharedUpload(file, {
        skipValidation: true,
        vendorMedia: {
          vendorType: "retailer_wholesaler",
          vendorId: productDetails.retailerWholesalerId || ownerVendorId,
          assetPurpose,
          entityType: "retailerWholesalerProduct",
          entityId: productId,
          source: "dashboard",
        },
      });
      const secureUrl = result.secure_url;
      setProductDetails((prevProduct) => ({
        ...prevProduct,
        image: secureUrl,
      }));
      setUploading(false);
      setShowPreviewModal(false);
      return secureUrl;
    } catch (error) {
      console.error("Error uploading the image:", error);
      toast.error(`Failed to upload image: ${error.message}`);
      setUploading(false);
      setShowPreviewModal(false);
      return null;
    }
  };

  const handleOptionGroupSubmit = async (e) => {
    e.preventDefault();

    const optionGroupData = {
      name: optionGroupName,
      retailerWholesalerProductId: productId,
      options: selectedOptions.map((option) => ({
        value: option.value,
        mandatory: option.mandatory,
      })),
      minOptions,
      maxOptions,
      owner: vendorId,
    };

    try {
      await dispatch(createRetailerWholesalerOptionGroup(optionGroupData));
      // toast.success("Option group created successfully!");
      dispatch(fetchRetailerWholesalerOptionGroups(vendorId));
      setShowOptionGroupModal(false);
      setOptionGroupName("");
      setSelectedOptions([]);
      setMinOptions(0);
      setMaxOptions(0);
    } catch (error) {
      toast.error(
        "Failed to create option group: " +
        (error.response?.data?.message || error.message)
      );
    }
  };

  const handleDeleteProduct = async () => {
    try {
      await dispatch(deleteRetailerWholesalerProduct(productId));
      // toast.success('Product deleted successfully');
      history.push("/admin/catalog");
    } catch (error) {
      toast.error("Failed to delete the product. Please try again.");
    }
  };

  const loadUnit = async (inputValue) => {
    setIsLoadingUnits(true);
    try {
      const res = await fetch(`/unit`);
      const units = await res.json();

      // Grouped by family; plural duplicates left out unless this product uses one.
      const groups = unitSelectOptions(Array.isArray(units) ? units : [], selectedUnit?.value);
      if (!inputValue) {
        return groups;
      }
      const needle = inputValue.toLowerCase();
      return groups
        .map((group) => ({
          ...group,
          options: group.options.filter((unit) => unit.label.toLowerCase().includes(needle)),
        }))
        .filter((group) => group.options.length);
    } catch (error) {
      console.error("Error loading units:", error);
      return [];
    } finally {
      setIsLoadingUnits(false);
    }
  };

  // handle Unit Selection
  const handleUnitChange = (selectedOption) => {
    setSelectedUnit(selectedOption);
    setProductDetails((prev) => ({
      ...prev,
      unit_id: selectedOption ? selectedOption.value : null,
    }));
  };

  //   Handle Unit Input Change
  const handleUnitInputChange = (value) => {
    // setSelectedUnit(value);
    setValue(value);
  };

  // Handle input change in AsyncSelect
  const handleCategoryInputChange = (value) => {
    setValue(value);
  };

  // Handle category selection change
  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
  };

  function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
    return centerCrop(
      makeAspectCrop(
        {
          unit: "%",
          width: 90,
          height: 90,
        },
        aspect,
        mediaWidth,
        mediaHeight
      ),
      mediaWidth,
      mediaHeight
    );
  }

  const handleImageLoad = (e) => {
    const { width, height } = e.currentTarget;
    let initialCrop;

    if (aspect) {
      initialCrop = centerAspectCrop(width, height, aspect);
    } else {
      initialCrop = {
        unit: "%",
        x: 10,
        y: 10,
        width: 80,
        height: 80,
      };
    }

    setCrop(initialCrop);
    setCompletedCrop(initialCrop);
  };

  const handleAspectChange = (newAspect) => {
    setAspect(newAspect);

    if (imgRef.current) {
      const { width, height } = imgRef.current;
      const newCrop = newAspect
        ? centerAspectCrop(width, height, newAspect)
        : {
          unit: "%",
          x: 10,
          y: 10,
          width: 80,
          height: 80,
        };

      setCrop(newCrop);
      setCompletedCrop(newCrop);
    }
  };

  const handleSaveCrop = useCallback(async () => {
    if (!imgRef.current || !completedCrop) return;

    const canvas = document.createElement("canvas");
    const image = imgRef.current;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    canvas.width = completedCrop.width * scaleX;
    canvas.height = completedCrop.height * scaleY;

    const ctx = canvas.getContext("2d");
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      completedCrop.x * scaleX,
      completedCrop.y * scaleY,
      completedCrop.width * scaleX,
      completedCrop.height * scaleY,
      0,
      0,
      canvas.width,
      canvas.height
    );

    // Convert canvas to base64 string for preview
    const base64Image = canvas.toDataURL("image/jpeg", 1.0);

    // Create blob and URL for preview
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }

        // Create a URL for the blob
        const previewUrl = URL.createObjectURL(blob);

        setProductDetails((prev) => ({
          ...prev,
          image: base64Image, // Store base64 for upload
        }));
        setImagePreview(previewUrl); // Use blob URL for preview
        setShowPreviewModal(false);
        setIsResolutionCorrect(true);
      },
      "image/jpeg",
      1
    );
  }, [completedCrop]);

  // Add cleanup for blob URLs
  useEffect(() => {
    return () => {
      // Cleanup any existing preview URL when component unmounts
      if (imagePreview && imagePreview.startsWith("blob:")) {
        URL.revokeObjectURL(imagePreview);
      }
    };
  }, [imagePreview]);

  // Add this useEffect for preview canvas updates
  useEffect(() => {
    if (
      completedCrop?.width &&
      completedCrop?.height &&
      imgRef.current &&
      previewCanvasRef.current
    ) {
      const image = imgRef.current;
      const canvas = previewCanvasRef.current;
      const crop = completedCrop;

      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;
      const ctx = canvas.getContext("2d");

      const pixelRatio = window.devicePixelRatio;

      canvas.width = crop.width * pixelRatio;
      canvas.height = crop.height * pixelRatio;

      ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      ctx.imageSmoothingQuality = "high";

      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );
    }
  }, [completedCrop]);

  // High-value products are locked to online-payment-only: the COD toggle is
  // forced on-disabled and can't be turned back on while the price is over the
  // live threshold.
  const codLockedByPrice =
    codMaxAmount != null && Number(productDetails?.price) > codMaxAmount;

  // Step numbers are handed out during render instead of hardcoded into each
  // label. "Minimum Order Volume" only renders for wholesalers, so with fixed
  // labels every retailer saw the sequence jump 6 → 8 and wondered what they
  // had missed. `step()` is called in JSX source order and `&&`-guarded blocks
  // short-circuit before reaching it, so a hidden field consumes no number.
  // Reset on every render — this must not be hoisted out of the component.
  let stepNo = 0;
  const step = (text) => `${(stepNo += 1)}. ${text}`;

  return (
    /* Non-fluid, centered container caps the form width on large screens so it
       reads as a focused document instead of sprawling edge-to-edge. */
    <Container className="vendor-product-form">
      <Row className="justify-content-center">
        <Col md={11} lg={10} xl={9}>
          <Card className="mt-3">
            <Card.Body>
              <Card.Title
                style={{
                  fontSize: "1.5rem",
                  fontWeight: 500,
                  marginBottom: "20px",
                }}
                as="h2"
              >
                Edit Product
              </Card.Title>
              <Button
                variant="danger"
                style={{
                  position: "absolute",
                  right: "20px",
                  top: "20px",
                }}
                onClick={() => setShowDeleteModal(true)}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <FaTrash
                    style={{
                      fontSize: "1.5rem",
                      color: "white",
                    }}
                    aria-label="Delete Product"
                  />
                  <span style={{ marginLeft: "0.5rem", color: "white" }}>
                    Delete Product
                  </span>
                </div>
              </Button>
              <hr />
              <div className="text-muted">
                <div style={{ marginBottom: "0", fontSize: "10px" }}>
                  <strong>Product ID: </strong>
                  {productDetails._id}
                </div>
                <div style={{ marginBottom: "0", fontSize: "10px" }}>
                  <strong>Created at: </strong>
                  {format(
                    new Date(productDetails.createdAt),
                    "MMMM dd, yyyy h:mm a"
                  )}
                </div>
                <div style={{ marginBottom: "0", fontSize: "10px" }}>
                  <strong>Updated at: </strong>
                  {format(
                    new Date(productDetails.updatedAt),
                    "MMMM dd, yyyy h:mm a"
                  )}
                </div>
              </div>
              <Form onSubmit={handleSubmit}>
                {/* Vendor team permissions: what this login may change here. */}
                {gate.pricingOnly && (
                  <Alert variant="info" className="mb-3">
                    Your role allows price changes only. Every other field is locked; Save will update the pricing fields.
                  </Alert>
                )}
                {gate.readOnly && (
                  <Alert variant="warning" className="mb-3">
                    {gate.readOnlyMessage}
                  </Alert>
                )}

                {/* Cover image, extra angles, photo tips and the phone-shoot
                    entry point all now live in one shared component used by the
                    Create form too — see components/ProductImageSection.js for
                    why the device upload became the primary control. */}
                <ProductImageSection
                  label={step("Product image")}
                  image={productDetails.image}
                  onFileSelected={handleImageFile}
                  onRemoveImage={() => {
                    setProductDetails((prev) => ({ ...prev, image: null }));
                    // The old Delete Image button cleared `image` but left
                    // `imagePreview` set, so the crop modal could reopen on a
                    // picture that was no longer attached.
                    setImagePreview(null);
                    setUploadError(null);
                  }}
                  onEditImage={
                    productDetails.image && imagePreview
                      ? () => setShowPreviewModal(true)
                      : undefined
                  }
                  uploadError={uploadError}
                  additionalImages={productDetails?.additionalImages || []}
                  onAdditionalImagesChange={(next) =>
                    setProductDetails((prev) => ({
                      ...prev,
                      additionalImages: next,
                    }))
                  }
                  onRequestDeleteSaved={setPhotoDeleteTarget}
                  vendorId={vendorId}
                  onShootImageSelected={(imageUrl) => {
                    setProductDetails((prev) => ({ ...prev, image: imageUrl }));
                    setImagePreview(imageUrl);
                    setUploadError(null);
                  }}
                  disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                />

                <ProductVideoSection
                  videos={productDetails?.videos || []}
                  onChange={(next) =>
                    setProductDetails((prev) => ({ ...prev, videos: next }))
                  }
                  disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                />

                <Form.Group className="mb-3">
                  <Form.Label>{step("Title")}</Form.Label>
                  <Form.Control disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                    type="text"
                    placeholder="Enter product name"
                    name="name"
                    value={productDetails.name || ""}
                    onChange={handleInputChange}
                    maxLength={40}
                    required
                  />
                  <Form.Text
                    className={
                      (productDetails.name || "").length >= 40
                        ? "text-danger"
                        : "text-muted"
                    }
                  >
                    {(productDetails.name || "").length}/40 characters
                  </Form.Text>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>{step("Description")}</Form.Label>
                  {/* Standardized WYSIWYG editor (shared toolbar config):
                      the formatting shown here is exactly what customers
                      see on the storefront. Sanitized server-side; a plain
                      text copy is derived for the mobile apps. The injected
                      typography CSS makes the editor content render with the
                      SAME font/size/spacing as the storefront description. */}
                  <style>{DESCRIPTION_TYPOGRAPHY_CSS}</style>
                  <ReactQuill
                    theme="snow"
                    className={DESCRIPTION_EDITOR_CLASS}
                    value={descriptionHtml}
                    onChange={setDescriptionHtml}
                    modules={DESCRIPTION_QUILL_MODULES}
                    formats={DESCRIPTION_QUILL_FORMATS}
                    placeholder="Describe the product — key features, specs, what makes it great…"
                    readOnly={submitting}
                    style={{ backgroundColor: "#fff" }}
                  />
                  <Form.Text className="text-muted">
                    Use headings, bold and bullet lists — customers see this
                    formatting exactly as shown here.
                  </Form.Text>
                </Form.Group>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>{step("Choose section")}</Form.Label>
                      <AppSelect block disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                        name="sectionId"
                        value={productDetails.sectionId || ""}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Choose...</option>
                        {sections.map((section) => (
                          <option key={section._id} value={section._id}>
                            {section.title}
                          </option>
                        ))}
                      </AppSelect>
                      {formErrors.section && (
                        <Alert variant="danger">{formErrors.section}</Alert>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>{step("Retailer / wholesaler")}</Form.Label>
                      <AppSelect block disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                        name="retailerWholesalerId"
                        value={productDetails.retailerWholesalerId || ""}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Choose...</option>
                        {retailersWholesalers.map((rw) => (
                          <option key={rw._id} value={rw._id}>
                            {rw.name}
                          </option>
                        ))}
                      </AppSelect>
                      {formErrors.retailerWholesaler && (
                        <Alert variant="danger">
                          {formErrors.retailerWholesaler}
                        </Alert>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                {/* Numeric fields pair off into rows: each is a short input that
                    was claiming a full-width line of its own, which is most of
                    why this form scrolled so far. */}
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>{step("Price")}</Form.Label>
                      <Form.Control disabled={gate.lockPricing} title={gate.pricingTitle}
                        type="number"
                        placeholder="Enter product price"
                        name="price"
                        value={productDetails.price || 0}
                        onChange={handleInputChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    {/* Minimum Order Volume */}
                    {operationMode === "WHOLESALER" && (
                      <Form.Group className="mb-3">
                        <Form.Label>{step("Minimum order volume (units)")}</Form.Label>
                        <Form.Control disabled={gate.lockPricing} title={gate.pricingTitle}
                          type="number"
                          placeholder="Enter minimum order volume"
                          name="minimumOrderVolume"
                          value={productDetails.minimumOrderVolume || 0}
                          onChange={handleInputChange}
                        />
                      </Form.Group>
                    )}
                    <ProductFreightFields
                      product={productDetails}
                      setProduct={setProductDetails}
                      disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                    />
                    <Form.Group className="mb-3">
                      <Form.Label>{step("Count in stock")}</Form.Label>
                      <Form.Control disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                        type="number"
                        placeholder="Enter count in stock"
                        name="countInStock"
                        value={productDetails.countInStock || 1}
                        onChange={handleInputChange}
                        min="1"
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    {/* Measurement */}
                    <Form.Group className="mb-3">
                      <Form.Label>{step("Measurement")}</Form.Label>
                      <Form.Control disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                        type="number"
                        placeholder="Enter product measurement"
                        name="measurements"
                        value={productDetails.measurements || 1}
                        onChange={handleInputChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    {/* Units */}
                    <Form.Group className="mb-3">
                      <Form.Label>{step("Unit")}</Form.Label>
                      <AsyncSelect isDisabled={gate.lockCatalogue}
                        cacheOptions
                        defaultOptions
                        value={selectedUnit}
                        loadOptions={loadUnit}
                        onInputChange={handleUnitInputChange}
                        onChange={handleUnitChange}
                        placeholder="Select measurement unit..."
                        isClearable={true}
                        isLoading={isLoadingUnits}
                        loadingMessage={() => "Fetching units..."}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    {/* Categories */}
                    <Form.Group className="mb-3">
                      <Form.Label>{step("Category association (optional)")}</Form.Label>{" "}
                      <AsyncSelect isDisabled={gate.lockCatalogue}
                        cacheOptions
                        defaultOptions
                        value={selectedCategory}
                        loadOptions={loadCategory}
                        onInputChange={handleCategoryInputChange}
                        onChange={handleCategoryChange}
                        isMulti
                        placeholder="Select categories..."
                      />
                      <CategorySuggestions
                        name={productDetails.name}
                        unitId={selectedUnit?.value || productDetails.unit_id || null}
                        categories={categories}
                        selected={selectedCategory}
                        disabled={gate.lockCatalogue}
                        onAdd={(category) =>
                          setSelectedCategory((prev) => [
                            ...(prev || []),
                            { value: category._id, label: category.category },
                          ])
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>{step("Option groups")}</Form.Label>
                      <Select isDisabled={gate.lockCatalogue}
                        isMulti
                        options={optionGroups.map((optionGroup) => ({
                          value: optionGroup._id,
                          label: `${optionGroup.name} (Min: ${optionGroup.minOptions}, Max: ${optionGroup.maxOptions})`,
                        }))}
                        value={selectedOptionGroups}
                        onChange={setSelectedOptionGroups}
                        placeholder="Select option groups..."
                      />
                      <Button
                        variant="link"
                        className="p-0 mt-1"
                        style={{ fontSize: "0.8rem" }}
                        onClick={() => setShowOptionGroupModal(true)}
                      >
                        Create new option group
                      </Button>
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Label className={classes.label}>Customer payment requirement</Form.Label>
                  <AppSelect block
                    name="requiredPaymentMethod"
                    value={
                      codLockedByPrice &&
                      (productDetails.requiredPaymentMethod ||
                        (productDetails.codDisabled ? "ANY_ONLINE" : "NONE")) === "NONE"
                        ? "ANY_ONLINE"
                        : productDetails.requiredPaymentMethod ||
                          (productDetails.codDisabled ? "ANY_ONLINE" : "NONE")
                    }
                    onChange={(e) =>
                      setProductDetails({
                        ...productDetails,
                        requiredPaymentMethod: e.target.value,
                        codDisabled: e.target.value !== "NONE",
                      })
                    }
                    disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                  >
                    {!codLockedByPrice && (
                      <option value="NONE">Any method (Cash on Delivery allowed)</option>
                    )}
                    <option value="ANY_ONLINE">Require payment before acceptance (any online method)</option>
                    <option value="MOMO">MTN Mobile Money only</option>
                    <option value="AIRTEL">Airtel Money only</option>
                    <option value="VISA">Card only</option>
                    <option value="ZAMTEL">Zamtel Kwacha only</option>
                  </AppSelect>
                  <Form.Text className="text-muted">
                    {codLockedByPrice
                      ? `This price is above the COD limit${codMaxAmount != null ? ` (UGX ${Number(codMaxAmount).toLocaleString()})` : ""}; online payment is required.`
                      : "Prepaid orders remain locked until Lusuku confirms payment."}
                  </Form.Text>
                </Form.Group>
                {/* Vendor discount: the list price above stays; the sale price is derived on read. */}
                <DiscountFields
                  disabled={gate.lockPricing}
                  title={gate.pricingTitle}
                  value={productDetails.discount}
                  onChange={(next) => setProductDetails((prev) => ({ ...prev, discount: next }))}
                  listPrice={productDetails.price}
                />

                <Form.Group className="mb-3">
                  <FormControlLabel
                    control={
                      <Switch
                        checked={productDetails.enabled}
                        onChange={(e) =>
                          setProductDetails({
                            ...productDetails,
                            enabled: e.target.checked,
                          })
                        }
                        name="enabled"
                        color="secondary"
                        disabled={gate.lockActivation} title={gate.activationTitle}
                      />
                    }
                    label={
                      productDetails.enabled
                        ? "Activate Product For Customers"
                        : "Deactivate Product For Customers"
                    }
                    classes={{ label: classes.label }}
                  />
                </Form.Group>

                <Button
                  variant="secondary"
                  style={{
                    marginRight: "10px",
                    color: submitting ? "#6c757d" : "white",
                  }}
                  onClick={() => history.goBack()}
                  disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                >
                  Discard Changes
                </Button>

                <Button
                  variant="primary"
                  type="submit"
                  style={{
                    color: submitting ? "#6c757d" : "white",
                  }}
                  disabled={gate.lockSubmit} title={gate.submitTitle}
                >
                  {submitting ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    "Save Changes"
                  )}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Modal
        show={showPreviewModal}
        onHide={() => setShowPreviewModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center justify-content-between w-100">
            <span>Crop and Preview Image</span>
            <div className="d-flex gap-2">
              <Tooltip title="Free Crop">
                <IconButton
                  size="small"
                  onClick={() => handleAspectChange(undefined)}
                  style={{
                    backgroundColor: !aspect
                      ? "rgba(25, 118, 210, 0.12)"
                      : "transparent",
                    color: !aspect ? "#1976d2" : "rgba(0, 0, 0, 0.54)",
                  }}
                >
                  <MdCrop size={20} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Square (1:1)">
                <IconButton
                  size="small"
                  onClick={() => handleAspectChange(1)}
                  style={{
                    backgroundColor:
                      aspect === 1 ? "rgba(25, 118, 210, 0.12)" : "transparent",
                    color: aspect === 1 ? "#1976d2" : "rgba(0, 0, 0, 0.54)",
                  }}
                >
                  <MdCropSquare size={20} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Landscape (16:9)">
                <IconButton
                  size="small"
                  onClick={() => handleAspectChange(16 / 9)}
                  style={{
                    backgroundColor:
                      aspect === 16 / 9
                        ? "rgba(25, 118, 210, 0.12)"
                        : "transparent",
                    color:
                      aspect === 16 / 9 ? "#1976d2" : "rgba(0, 0, 0, 0.54)",
                  }}
                >
                  <MdCropLandscape size={20} />
                </IconButton>
              </Tooltip>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {uploadError && (
            <Alert variant="danger" className="mb-3">
              {uploadError}
            </Alert>
          )}
          <div className="d-flex">
            <div
              className="flex-grow-1"
              style={{
                maxHeight: "70vh",
                overflow: "auto",
                backgroundColor: "#f0f0f0",
                borderRadius: "4px",
                padding: "16px",
              }}
            >
              {imagePreview && (
                <ReactCrop
                  crop={crop}
                  onChange={(_, percentCrop) => setCrop(percentCrop)}
                  onComplete={(c) => setCompletedCrop(c)}
                  aspect={aspect}
                  minWidth={aspect ? MIN_DIMENSION : undefined}
                  minHeight={aspect ? MIN_DIMENSION : undefined}
                >
                  <img
                    ref={imgRef}
                    alt="Crop me"
                    src={imagePreview}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "70vh",
                      objectFit: "contain",
                    }}
                    onLoad={handleImageLoad}
                  />
                </ReactCrop>
              )}
            </div>
            <div
              className="ms-3"
              style={{
                width: "280px",
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <h6>Preview</h6>
              <div
                style={{
                  width: "100%",
                  aspectRatio: "1",
                  overflow: "hidden",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "4px",
                }}
              >
                <canvas
                  ref={previewCanvasRef}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowPreviewModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSaveCrop}
            disabled={!completedCrop?.width || !completedCrop?.height}
          >
            Save Cropped Image
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showOptionGroupModal}
        onHide={() => setShowOptionGroupModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Create New Option Group</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleOptionGroupSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Option Group Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter option group name"
                value={optionGroupName}
                onChange={(e) => setOptionGroupName(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Options</Form.Label>
              <Select
                isMulti
                options={options.map((option) => ({
                  value: option._id,
                  label: option.name,
                }))}
                value={selectedOptions}
                onChange={setSelectedOptions}
                placeholder="Select options..."
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Min Options</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter minimum options"
                value={minOptions}
                onChange={(e) => setMinOptions(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Max Options</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter maximum options"
                value={maxOptions}
                onChange={(e) => setMaxOptions(e.target.value)}
                required
              />
            </Form.Group>

            <Button
              variant="secondary"
              onClick={() => setShowOptionGroupModal(false)}
            >
              Cancel
            </Button>
            <Button variant="primary" type="submit" className="ms-2">
              Create
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this product? This action cannot be
          undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteProduct}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <ProductMediaDeleteDialog
        target={photoDeleteTarget}
        productType="retailer_wholesaler"
        productId={productId}
        productName={productDetails?.name}
        image={productDetails?.image}
        additionalImages={productDetails?.additionalImages}
        onClose={() => setPhotoDeleteTarget(null)}
        onRemoved={({ image, additionalImages }) =>
          setProductDetails((prev) => ({ ...prev, image, additionalImages }))
        }
      />
    </Container>
  );
};

export default EditCatalogProductForm;
